import axios from "axios";

const resolveApiBaseUrl = () => {
  if (typeof window === "undefined") {
    return "https://ecare.rmc2.com.ph/api/v1";
  }

  const host = window.location.hostname;
  if (host === "dev-ecare.rmc2.com.ph") {
    return `https://${host}/api/v1`;
  }
  if (host === "ecare.rmc2.com.ph") {
    return `https://${host}/api/v1`;
  }

  return "https://ecare.rmc2.com.ph/api/v1";
};

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default api;
